window.themeMoneyFormat = window.themeMoneyFormat || '${{amount}}';
window.jouffaStrings = window.jouffaStrings || {};

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.themeMoneyFormat || '${{amount}}';

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var centsPart = parts[1] ? decimal + parts[1] : '';
    return dollars + centsPart;
  }

  var match = formatString.match(placeholderRegex);
  if (!match) {
    return formatWithDelimiters(cents, 2);
  }

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

window.formatMoney = formatMoney;

var cartState = { cart: null };

function updateCartCount(count) {
  if (typeof count !== 'number' && cartState.cart) {
    count = cartState.cart.item_count;
  }
  document.querySelectorAll('.jouffa-cart-count').forEach(function (el) {
    el.textContent = count || 0;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function renderCart() {
  var container = document.getElementById('jouffa-drawer-items');
  var footer = document.querySelector('.jouffa-drawer-footer');
  var totalEl = document.getElementById('jouffa-drawer-total_price');
  if (!container) {
    return;
  }

  var strings = window.jouffaStrings;
  var drawer = document.getElementById('jouffa-cart-drawer');
  var catalogUrl = (drawer && drawer.getAttribute('data-catalog-url')) || '/collections/all';
  if (!cartState.cart || cartState.cart.item_count === 0) {
    container.innerHTML =
      '<div class="jouffa-drawer-empty">' +
      '<p>' + (strings.emptyCart || 'Your cart is empty.') + '</p>' +
      '<a href="' + catalogUrl + '" class="jouffa-primary-button">' +
      (strings.startShopping || 'Start shopping') +
      '</a></div>';
    if (footer) {
      footer.hidden = true;
    }
    if (totalEl) {
      totalEl.textContent = formatMoney(0);
    }
    return;
  }

  if (footer) {
    footer.hidden = false;
  }
  if (totalEl) {
    totalEl.textContent = formatMoney(cartState.cart.total_price);
  }

  var html = '';
  cartState.cart.items.forEach(function (item) {
    var imageSrc = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
    var variantLine = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      variantLine = '<div class="jouffa-drawer-item-variant">' + item.variant_title + '</div>';
    }
    html +=
      '<div class="jouffa-drawer-item">' +
      '<div class="jouffa-drawer-item-image"><img src="' + imageSrc + '" alt=""></div>' +
      '<div class="jouffa-drawer-item-info">' +
      '<a href="' + item.url + '" class="jouffa-drawer-item-title">' + item.product_title + '</a>' +
      variantLine +
      '<div class="jouffa-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>' +
      '<div class="jouffa-drawer-item-actions">' +
      '<div class="jouffa-qty-selector">' +
      '<button type="button" data-qty-key="' + item.key + '" data-qty-value="' + (item.quantity - 1) + '">-</button>' +
      '<input type="number" value="' + item.quantity + '" readonly>' +
      '<button type="button" data-qty-key="' + item.key + '" data-qty-value="' + (item.quantity + 1) + '">+</button>' +
      '</div>' +
      '<button type="button" class="jouffa-remove-link" data-qty-key="' + item.key + '" data-qty-value="0">' +
      (strings.remove || 'Remove') +
      '</button></div></div></div>';
  });
  container.innerHTML = html;
}

async function fetchCart() {
  try {
    var res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js');
    cartState.cart = await res.json();
    renderCart();
    updateCartCount(cartState.cart.item_count);
  } catch (err) {
    console.error('Error fetching cart:', err);
  }
}

window.openCartDrawer = function () {
  var drawer = document.getElementById('jouffa-cart-drawer');
  if (!drawer) {
    return;
  }
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  fetchCart();
};

window.closeCartDrawer = function () {
  var drawer = document.getElementById('jouffa-cart-drawer');
  if (!drawer) {
    return;
  }
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

window.changeQty = async function (key, newQty) {
  try {
    var res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    cartState.cart = await res.json();
    renderCart();
    updateCartCount(cartState.cart.item_count);
  } catch (err) {
    console.error('Error updating cart:', err);
  }
};

function productAddButton() {
  var form = document.getElementById('product-form-installment');
  if (form) {
    return form.querySelector('[data-add-to-cart]');
  }
  return document.querySelector('[data-add-to-cart]');
}

window.addToCart = async function (formData) {
  var btn = productAddButton();
  var stickyBtn = document.querySelector('#jouffa-sticky-bar [data-sticky-add]');
  var strings = window.jouffaStrings;
  var originalText = btn ? btn.innerHTML : strings.addToCart || 'Add to cart';

  if (btn) {
    btn.innerHTML = strings.adding || 'Adding...';
  }
  if (stickyBtn) {
    stickyBtn.innerHTML = '...';
  }

  try {
    var response = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      if (btn) {
        btn.innerHTML = strings.added || 'Added';
      }
      if (stickyBtn) {
        stickyBtn.innerHTML = strings.added || 'Added';
      }
      await fetchCart();
      window.openCartDrawer();
      setTimeout(function () {
        if (btn) {
          btn.innerHTML = originalText;
        }
        if (stickyBtn) {
          stickyBtn.innerHTML = strings.addShort || 'Add';
        }
      }, 1600);
    } else {
      if (btn) {
        btn.innerHTML = strings.error || 'Error';
      }
    }
  } catch (error) {
    console.error('Fetch error:', error);
    if (btn) {
      btn.innerHTML = strings.error || 'Error';
    }
  }
};

function sizedImageUrl(src, width) {
  if (!src) {
    return '';
  }
  var url = src;
  if (url.indexOf('//') === 0) {
    url = 'https:' + url;
  }
  if (url.indexOf('http:') === 0) {
    url = url.replace('http:', 'https:');
  }
  try {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('width', String(width));
    return parsed.toString();
  } catch (e) {
    return url;
  }
}

function imageKey(src) {
  return (src || '').split('?')[0];
}

function loadGalleryConfig() {
  var el = document.getElementById('ProductGalleryJson');
  if (!el) {
    return { title: '', fallback: null, shared: [] };
  }
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return { title: '', fallback: null, shared: [] };
  }
}

function slidesForVariant(variant) {
  var config = loadGalleryConfig();
  var slides = [];
  var seen = {};

  function addSlide(image) {
    if (!image || !image.src) {
      return;
    }
    var key = imageKey(image.src);
    if (seen[key]) {
      return;
    }
    seen[key] = true;
    slides.push({
      src: sizedImageUrl(image.src, 1400),
      thumb: image.thumb || sizedImageUrl(image.src, 200),
      alt: image.alt || config.title || '',
      width: image.width || 1400,
      height: image.height || 1400
    });
  }

  if (variant && variant.featured_image && variant.featured_image.src) {
    addSlide(variant.featured_image);
  }
  (config.shared || []).forEach(addSlide);
  if (slides.length === 0) {
    addSlide(config.fallback);
  }
  return slides;
}

function currentGalleryImage() {
  var active = document.querySelector('.jouffa-gallery__slide.is-active img');
  if (active) {
    return active;
  }
  return document.getElementById('JouffaMainImage');
}

function setGalleryIndex(index, smooth) {
  var track = document.querySelector('[data-gallery-track]');
  if (!track) {
    return;
  }
  var slides = track.querySelectorAll('.jouffa-gallery__slide');
  if (!slides.length) {
    return;
  }
  var nextIndex = ((index % slides.length) + slides.length) % slides.length;
  var target = slides[nextIndex];
  track.scrollTo({
    left: target.offsetLeft,
    behavior: smooth ? 'smooth' : 'auto'
  });
  slides.forEach(function (slide, i) {
    slide.classList.toggle('is-active', i === nextIndex);
    var img = slide.querySelector('img');
    if (img) {
      img.id = i === nextIndex ? 'JouffaMainImage' : '';
    }
  });
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb, i) {
    thumb.classList.toggle('is-selected', i === nextIndex);
  });
}

function renderGallery(slides) {
  var root = document.querySelector('[data-gallery]');
  var track = document.querySelector('[data-gallery-track]');
  var thumbs = document.querySelector('[data-gallery-thumbs]');
  if (!root || !track) {
    return;
  }

  root.setAttribute('data-count', String(slides.length));
  track.replaceChildren();
  if (thumbs) {
    thumbs.replaceChildren();
    thumbs.hidden = slides.length < 2;
  }

  slides.forEach(function (slide, index) {
    var slideEl = document.createElement('div');
    slideEl.className = 'jouffa-gallery__slide' + (index === 0 ? ' is-active' : '');
    slideEl.setAttribute('data-gallery-index', String(index));
    var img = document.createElement('img');
    img.src = slide.src;
    img.alt = slide.alt;
    img.width = slide.width;
    img.height = slide.height;
    img.loading = index === 0 ? 'eager' : 'lazy';
    if (index === 0) {
      img.id = 'JouffaMainImage';
      img.setAttribute('fetchpriority', 'high');
    }
    slideEl.appendChild(img);
    track.appendChild(slideEl);

    if (thumbs && slides.length > 1) {
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'jouffa-gallery__thumb' + (index === 0 ? ' is-selected' : '');
      thumb.setAttribute('data-gallery-thumb', String(index));
      var thumbImg = document.createElement('img');
      thumbImg.src = slide.thumb;
      thumbImg.alt = '';
      thumbImg.width = 80;
      thumbImg.height = 80;
      thumbImg.loading = 'lazy';
      thumb.appendChild(thumbImg);
      thumbs.appendChild(thumb);
    }
  });

  document.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(function (button) {
    button.hidden = slides.length < 2;
  });

  setGalleryIndex(0, false);
}

function initGallery() {
  var root = document.querySelector('[data-gallery]');
  if (!root) {
    return;
  }

  var track = document.querySelector('[data-gallery-track]');
  root.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-gallery-prev]');
    var next = event.target.closest('[data-gallery-next]');
    var thumb = event.target.closest('[data-gallery-thumb]');
    var zoom = event.target.closest('[data-gallery-zoom]');
    var slides = track ? track.querySelectorAll('.jouffa-gallery__slide') : [];
    var active = track ? track.querySelector('.jouffa-gallery__slide.is-active') : null;
    var current = active ? Array.prototype.indexOf.call(slides, active) : 0;

    if (prev) {
      setGalleryIndex(current - 1, true);
    }
    if (next) {
      setGalleryIndex(current + 1, true);
    }
    if (thumb) {
      setGalleryIndex(parseInt(thumb.getAttribute('data-gallery-thumb'), 10), true);
    }
    if (zoom) {
      var zoomDialog = document.getElementById('jouffa-zoom-dialog');
      var zoomImage = document.getElementById('jouffa-zoom-image');
      var currentImg = currentGalleryImage();
      if (zoomDialog && zoomImage && currentImg && typeof zoomDialog.showModal === 'function') {
        zoomImage.src = currentImg.currentSrc || currentImg.src;
        zoomImage.alt = currentImg.alt || '';
        zoomDialog.showModal();
      }
    }
  });

  if (track) {
    track.addEventListener('scroll', function () {
      var slides = track.querySelectorAll('.jouffa-gallery__slide');
      if (!slides.length) {
        return;
      }
      var index = Math.round(track.scrollLeft / slides[0].clientWidth);
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb, i) {
        thumb.classList.toggle('is-selected', i === index);
      });
    }, { passive: true });
  }

  var zoomDialog = document.getElementById('jouffa-zoom-dialog');
  if (zoomDialog) {
    zoomDialog.addEventListener('click', function (event) {
      if (event.target === zoomDialog) {
        zoomDialog.close();
      }
    });
  }
}

function getSelectedOptions() {
  var groups = document.querySelectorAll('[data-option-group]');
  return Array.prototype.map.call(groups, function (group) {
    var selected = group.querySelector('.jouffa-option-btn.is-selected');
    return selected ? selected.getAttribute('data-value') : '';
  });
}

function onVariantChange() {
  var jsonEl = document.getElementById('ProductVariantsJson');
  if (!jsonEl) {
    return;
  }
  var variantData = JSON.parse(jsonEl.textContent);
  var selectedOptions = getSelectedOptions();
  var addToCartBtn = productAddButton();
  var stickyAdd = document.querySelector('#jouffa-sticky-bar [data-sticky-add]');
  var priceDisplay = document.querySelector('[data-product-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var hiddenInput = document.querySelector('[data-variant-id]');
  var strings = window.jouffaStrings;

  var matchedVariant = variantData.find(function (variant) {
    return selectedOptions.every(function (val, index) {
      return variant.options[index] === val;
    });
  });

  if (matchedVariant) {
    if (hiddenInput) {
      hiddenInput.value = matchedVariant.id;
    }
    if (priceDisplay) {
      var priceHTML = formatMoney(matchedVariant.price);
      if (matchedVariant.compare_at_price > matchedVariant.price) {
        priceHTML += ' <s class="jouffa-compare-price">' + formatMoney(matchedVariant.compare_at_price) + '</s>';
      }
      priceDisplay.innerHTML = priceHTML;
    }
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(matchedVariant.price);
    }
    if (addToCartBtn) {
      if (matchedVariant.available) {
        addToCartBtn.innerHTML = strings.addToCart || 'Add to cart';
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('is-disabled');
      } else {
        addToCartBtn.innerHTML = strings.soldOut || 'Sold out';
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('is-disabled');
      }
    }
    if (stickyAdd) {
      if (matchedVariant.available) {
        stickyAdd.innerHTML = strings.addShort || 'Add';
        stickyAdd.disabled = false;
      } else {
        stickyAdd.innerHTML = strings.soldOut || 'Sold out';
        stickyAdd.disabled = true;
      }
    }

    var newUrl = new URL(window.location);
    newUrl.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState(null, '', newUrl);

    renderGallery(slidesForVariant(matchedVariant));
  } else {
    if (addToCartBtn) {
      addToCartBtn.innerHTML = strings.unavailable || 'Unavailable';
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('is-disabled');
    }
    if (stickyAdd) {
      stickyAdd.innerHTML = strings.unavailable || 'Unavailable';
      stickyAdd.disabled = true;
    }
  }
}

window.onVariantChange = onVariantChange;

function clampQtyInput(input) {
  var min = parseInt(input.min || '1', 10);
  var value = parseInt(input.value, 10);
  if (isNaN(value) || value < min) {
    input.value = min;
  }
}

function initProductForm() {
  var form = document.getElementById('product-form-installment');
  if (!form) {
    return;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    window.addToCart(new FormData(form));
  });

  form.querySelectorAll('[data-qty-step]').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = form.querySelector('input[name="quantity"]');
      if (!input) {
        return;
      }
      var next = parseInt(input.value, 10) + parseInt(button.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.min || '1', 10);
      input.value = Math.max(min, next);
    });
  });

  var qtyInput = form.querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      clampQtyInput(qtyInput);
    });
    qtyInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        qtyInput.blur();
      }
    });
  }

  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    group.addEventListener('click', function (event) {
      var button = event.target.closest('.jouffa-option-btn');
      if (!button) {
        return;
      }
      group.querySelectorAll('.jouffa-option-btn').forEach(function (btn) {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      onVariantChange();
    });
  });

  initGallery();

  var stickyAdd = document.querySelector('[data-sticky-add]');
  if (stickyAdd) {
    stickyAdd.addEventListener('click', function () {
      form.requestSubmit();
    });
  }

  var mainBtn = productAddButton();
  var stickyBar = document.getElementById('jouffa-sticky-bar');
  if (mainBtn && stickyBar && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    });
    observer.observe(mainBtn);
  }

  onVariantChange();
}

function initRelatedProducts() {
  var section = document.querySelector('.product-recommendations');
  if (!section || !section.dataset.url) {
    return;
  }
  if (!('IntersectionObserver' in window)) {
    return;
  }
  var observer = new IntersectionObserver(function (entries, obs) {
    if (!entries[0].isIntersecting) {
      return;
    }
    obs.disconnect();
    fetch(section.dataset.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.querySelector('.jouffa-product-card')) {
          section.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(function (e) {
        console.error(e);
      });
  });
  observer.observe(section);
}

function initHeader() {
  var header = document.querySelector('.jouffa-final-header');
  var placeholder = document.getElementById('jouffa-header-placeholder');
  var announcementBar = document.getElementById('jouffa-announcement');
  if (announcementBar && localStorage.getItem('jouffa-announcement-dismissed') === '1') {
    announcementBar.hidden = true;
  }
  if (!header || !placeholder) {
    return;
  }
  window.addEventListener('scroll', function () {
    var offset = announcementBar && !announcementBar.hidden ? announcementBar.offsetHeight : 0;
    if (window.scrollY > offset) {
      header.classList.add('jouffa-sticky-active');
      placeholder.style.height = header.offsetHeight + 'px';
    } else {
      header.classList.remove('jouffa-sticky-active');
      placeholder.style.height = '0px';
    }
  }, { passive: true });
}

function initCartPage() {
  var cartForm = document.getElementById('cart');
  if (!cartForm) {
    return;
  }
  cartForm.querySelectorAll('.jouffa-cart-qty').forEach(function (input) {
    input.addEventListener('change', async function () {
      var key = input.getAttribute('data-line-key');
      var qty = parseInt(input.value, 10);
      if (!key || isNaN(qty)) {
        return;
      }
      await window.changeQty(key, Math.max(0, qty));
      window.location.reload();
    });
  });
}

function initCarousel() {
  document.querySelectorAll('.jouffa-carousel-wrapper').forEach(function (wrapper) {
    var track = wrapper.querySelector('.jouffa-carousel-track');
    if (!track) {
      return;
    }
    wrapper.querySelectorAll('[data-carousel-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        track.scrollBy({ left: parseInt(button.getAttribute('data-carousel-scroll'), 10), behavior: 'smooth' });
      });
    });
  });
}

document.addEventListener('click', function (event) {
  if (event.target.closest('[data-jouffa-open-drawer]')) {
    event.preventDefault();
    window.openCartDrawer();
  }
  if (event.target.closest('[data-jouffa-close-drawer]')) {
    window.closeCartDrawer();
  }
  if (event.target.closest('[data-jouffa-dismiss-announcement]')) {
    var bar = document.getElementById('jouffa-announcement');
    if (bar) {
      bar.hidden = true;
    }
    try {
      localStorage.setItem('jouffa-announcement-dismissed', '1');
    } catch (e) {}
  }
  var qtyBtn = event.target.closest('[data-qty-key]');
  if (qtyBtn) {
    window.changeQty(qtyBtn.getAttribute('data-qty-key'), parseInt(qtyBtn.getAttribute('data-qty-value'), 10));
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    window.closeCartDrawer();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  initHeader();
  initProductForm();
  initRelatedProducts();
  initCartPage();
  initCarousel();
  fetchCart();
});
